import React, { useEffect, useState } from 'react';
import { X, BellRing } from 'lucide-react';
interface NotificationBannerProps {
  message: string;
  onClose: () => void;
  autoClose?: boolean;
  duration?: number;
}
export function NotificationBanner({
  message,
  onClose,
  autoClose = true,
  duration = 5000
}: NotificationBannerProps) {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onClose, 300);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);
  if (!isVisible) return null;
  return <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 animate-fade-in" data-id="element-1257">
      <div className="bg-purple-600 text-white rounded-xl shadow-2xl p-4 flex items-center gap-3 max-w-md" data-id="element-1258">
        <BellRing size={24} className="flex-shrink-0" data-id="element-1259" />
        <p className="flex-1 font-medium text-sm" data-id="element-1260">{message}</p>
        <button onClick={() => {
        setIsVisible(false);
        setTimeout(onClose, 300);
      }} className="p-1 hover:bg-purple-700 rounded transition-colors" data-id="element-1261">
          <X size={18} data-id="element-1262" />
        </button>
      </div>
    </div>;
}